// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1YhDE","title":"AfterBackImages_title__3e8eP","images":"AfterBackImages_images__2NI8c"};